import { ThemeIcon } from 'ui';

interface ColoredMapMarkerProps {
  color: 'mint' | 'cobalt';
}

const MapPinMarker = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 25 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="map_pin">
        <g id="Rectangle Copy 6">
          <rect x="2" y="2" width="20" height="20" rx="50%" fill="currentColor" />
          <rect x="2" y="2" width="20" height="20" rx="50%" stroke="white" strokeWidth="4" />
        </g>
      </g>
    </svg>
  );
};

const MapMarker = ({ color = 'cobalt' }: ColoredMapMarkerProps) => {
  return (
    <ThemeIcon
      variant="transparent"
      c={color}
      size="lg"
      style={{ boxShadow: 'var(--mantine-shadow-sm' }}
    >
      <MapPinMarker />
    </ThemeIcon>
  );
};

export { MapMarker };
